import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {

  transform(inTime: any, outTime: any): string {
    if (!inTime || !outTime) return '--';

    const start = new Date(inTime).getTime();
    const end = new Date(outTime).getTime();

    if (end <= start) return '--';

    const diffInSeconds = Math.floor((end - start) / 1000);

    const hours = Math.floor(diffInSeconds / 3600);
    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    const seconds = diffInSeconds % 60;

    if (hours > 0) {
      return `${hours} hr${hours > 1 ? 's' : ''} ${minutes} min`;
    }

    if (minutes > 0) {
      return `${minutes} min ${seconds} sec`;
    }

    return `${seconds} sec`;
  }
}
